// extracted by mini-css-extract-plugin
export default {"DeleteIcon":"user-list_DeleteIcon__we5GU"};